<template>
    <div class="repair-ai-wrapper">
      <!-- Loading State -->
      <v-card v-if="loading" class="pa-5 text-center rounded-lg elevation-2">
        <v-progress-circular indeterminate color="primary" size="48" class="mb-3"></v-progress-circular>
        <div class="text-subtitle-1 font-weight-bold">Analyzing Vehicle & Diagnostic Codes...</div>
        <div class="text-caption grey--text">Querying Gemini AI for {{ data.year }} {{ data.make }} {{ data.model }}</div>
      </v-card>
  
      <!-- Error State -->
      <v-alert v-else-if="error" type="error" outlined class="mb-4">
        {{ error }}
        <v-btn small color="error" class="ml-3" @click="fetchDiagnosticReport">Retry</v-btn>
      </v-alert>
  
      <!-- Success: Pass response into DiagnosticKnowledgeHub -->
      <diagnostic-knowledge-hub
        v-else-if="aiResponse"
        :data="aiResponse"
        @add-line-item="handleSingleItem"
        @add-all-line-items="handleAllItems"
      />
    </div>
  </template>

<script>
import axios from "@/plugins/axios"
import DiagnosticKnowledgeHub from './DiagnosticKnowledgeHub.vue'

export default {
  name: 'RepairAi',
  components: {
    DiagnosticKnowledgeHub
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  computed:{
    getAccessToken(){
        return this.$store.getters.getAccessToken
    }
  },
  data() {
    return {
      loading: false,
      aiResponse: null,
      error: null
    }
  },
  mounted() {
    this.fetchDiagnosticReport();
  },
  methods: {
    async fetchDiagnosticReport() {
      this.loading = true;
      this.error = null;

      // Build context parameters safely from the job card data
      const payload = {
        vehicle: {
          year: this.data.year || '',
          make: this.data.make || '',
          model: this.data.model || '',
          style: this.data.style || '',
          vin: this.data.vin || '',
          mileage: this.data.mileage_in || ''
        },
        dtc_codes: this.data.obd_ii_error_codes || [],
        customer_issues: this.data.customer_reported_issues || ''
      };

      try {
        const response = await axios.postDataWithToken('/auth/repair-ai-get-diagnostics', {data: payload},this.getAccessToken);
        
        // Populate the child component with the Gemini JSON output
        if(response && response.status === 'success'){
            this.aiResponse = response.data;
        }
        
      } catch (err) {
        this.error = 'Failed to load diagnostic data. Please try again.';
        console.error('Gemini API Error:', err);
      } finally {
        this.loading = false;
      }
    },

    // Handle single line item emitted from the component
    handleSingleItem(item) {
      this.$emit('add-to-invoice', item);
    },

    // Handle bulk line items emitted from the component
    handleAllItems(items) {
      this.$emit('add-bulk-to-invoice', items);
    }
  }
}
</script>